import { getSportSetting } from '@/services/settings.service';

export const getSportMainBetTypes = (sport: number) => {
	const sportSetting = getSportSetting(sport);
	return sportSetting.oddsPageFilterBetTypes.flatMap(item => item.betTypes);
}

export const sportService = {
	getSportMainBetTypes
};